import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { verifyEmail } from '../services/authService'; // Funktion muss noch erstellt werden
import { Result, Button, Spin, Alert, Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const EmailVerificationPage = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('loading'); // 'loading', 'success', 'error'
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        const handleVerification = async () => {
            if (!token) {
                setStatus('error');
                setErrorMessage('Kein Verifizierungstoken gefunden.');
                return;
            }

            try {
                const response = await verifyEmail(token); // API-Aufruf
                if (response.success) {
                    setStatus('success');
                } else {
                    setStatus('error');
                    setErrorMessage(response.message || 'E-Mail-Verifizierung fehlgeschlagen.');
                }
            } catch (error) {
                setStatus('error');
                setErrorMessage(error.message || 'Ein unerwarteter Fehler ist aufgetreten.');
                console.error("Fehler bei der E-Mail-Verifizierung:", error);
            }
        };

        handleVerification();
    }, [token]); // Abhängigkeit vom Token

    if (status === 'loading') {
        return (
            <div style={{ textAlign: 'center', padding: '50px' }}>
                <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
                <Title level={3} style={{ marginTop: 20 }}>E-Mail wird verifiziert...</Title>
                <Paragraph>Bitte haben Sie einen Moment Geduld.</Paragraph>
            </div>
        );
    }

    if (status === 'success') {
        return (
            <Result
                status="success"
                title="E-Mail-Adresse erfolgreich bestätigt!"
                subTitle="Sie können sich jetzt mit Ihrer E-Mail-Adresse und Ihrem Passwort anmelden."
                extra={[
                    <Button type="primary" key="login" onClick={() => navigate('/login')}>
                        Zum Login
                    </Button>,
                ]}
                style={{ padding: '50px' }}
            />
        );
    }

    // status === 'error'
    return (
        <Result
            status="error"
            title="E-Mail-Verifizierung fehlgeschlagen"
            subTitle="Der Verifizierungslink ist möglicherweise ungültig oder abgelaufen."
            extra={[
                <Alert message={errorMessage || 'Unbekannter Fehler.'} type="error" showIcon style={{ marginBottom: 16 }} />,
                <Button type="default" key="home" onClick={() => navigate('/')}>
                    Zur Startseite
                </Button>,
                 <Button key="resend" onClick={() => navigate('/login')} style={{ marginLeft: 8 }}>
                    Erneut versuchen (via Login)
                </Button> // Ggf. bessere Option anbieten
            ]}
            style={{ padding: '50px' }}
        />
    );
};

export default EmailVerificationPage; 